module.exports = __webpack_public_path__ + "img/twilio.0df38fea.png";